import React from 'react';
import styled from 'styled-components';
import Typography from '../../common/typography/Typography'; // Ensure the path is correct

// Step Container
const StepsSection = styled.section`
   @media (min-width: 600px) {
    padding-left: 56px;
    padding-right: 56px;
  }
`;

const StepContainer = styled.div`
  display: flex;
  margin-bottom: 40px; 
  justify-content: space-between; 
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  @media (max-width: 768px) {
   
    flex-direction: column; 
    align-items: flex-start

  }
`;

const StepImage = styled.img`
  height: auto;
  @media (max-width: 768px) {
    width: 100%; 
    margin-bottom: 20px;
  }
`;
const StepBackground = styled.div`
  background-image: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center;
  width: 500px; 
  height: 500px; 
  
  @media (max-width: 768px) {
    width: 100%; 
    margin-bottom: 20px;
  }
`;
const StepTitle = styled.h2`

  margin: 0 0 10px; 
`;

const StepContent = styled.div`
  width: 50%; 
  padding: 20px; 

  @media (max-width: 768px) {
    width: 100%; 
    padding-left: 0;
  }
`;

const StepNumber = styled.img`
  width: 50px;
  height: auto;
`;

const CheckMoreButton = styled.button`
  width: 152px;
  height: 52px; 
  padding: 10px 15px;
  margin:5px 0;
  border: 0.1px solid #5A5869; 
  border-radius: 8px; 
  background-color: transparent; 
  color: #5A5869; 
  cursor: pointer;
  font-family: 'Gilroy', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  opacity: 1; 

  &:hover {
    background-color: #5B63F6; 
    color: white; 
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Illustrations = () => {
  return (
    <StepsSection>
      <StepContainer >
        <StepImage src={"./static/Illustration_1.svg"} alt="Step 1" />

        <StepContent>
          <StepNumber src={"./static/step_1.svg"} alt="Step 1" />
          <StepTitle><Typography size="40px" weight="700">Stay Aware: Know Your Screen Time</Typography></StepTitle>
          <Typography size="26px" weight="500" color={"#9897A1"}>
            We help you track and understand your screen time with detailed analytics and insights. 
            This allows you to make informed decisions about your digital habits, 
            helping you reduce excessive usage and stay aware of how you’re spending your time online.
          </Typography>
          <CheckMoreButton>Check More</CheckMoreButton>
        </StepContent>
      </StepContainer>
      <StepContainer reverse>
        <StepImage src={"./static/Illustration_2.svg"} alt="Step 2" />
        <StepContent>
          <StepNumber src={"./static/step_2.svg"} alt="Step 2" />
          <StepTitle><Typography size="40px" weight="700">Stay Busy: Explore Offline Activities</Typography></StepTitle>
          <Typography size="26px" weight="500" color={"#9897A1"}>
           Discover a wide range of engaging offline activities, 
           from hobbies and sports to cultural events and social gatherings.
           Our personalized recommendations help you reduce screen time,
           encouraging you to reconnect with the world and enjoy meaningful real-world experiences.

          </Typography>
          <CheckMoreButton>Check More</CheckMoreButton>
        </StepContent>

      </StepContainer>
      <StepContainer>
        <StepImage src={"./static/Illustration_3.svg"} alt="Step 3" />
        <StepContent>
          <StepNumber src={"./static/step_3.svg"} alt="Step 3" />
          <StepTitle> <Typography size="40px" weight="700">Stay Productive: Boost Your Productivity</Typography></StepTitle>
          <Typography size="26px" weight="500" color={"#9897A1"}>
            Use our powerful productivity tools to stay focused and get more done.
             From customizable to-do lists to app blockers and focus modes, 
             we provide everything you need to create a healthy balance between your online and offline tasks,
             maximizing your daily efficiency.


          </Typography>
          <CheckMoreButton>Check More</CheckMoreButton>
        </StepContent>
      </StepContainer>
      <StepContainer reverse>
        <StepImage src={"./static/Illustration_4.svg"} alt="Step 4" />
        <StepContent>
          <StepNumber src={"./static/step_4.svg"} alt="Step 4" />
          <StepTitle> <Typography size="40px" weight="700">Stay Motivated: Earn Rewards</Typography></StepTitle>
          <Typography size="26px" weight="500" color={"#9897A1"}>
          Participate in exciting challenges designed to reduce your screen time and improve your well-being.
           As you complete tasks, you'll earn valuable rewards like tickets or credits, 
           keeping you motivated to lead a balanced, 
          fulfilling digital and offline lifestyle.
          </Typography>
          <CheckMoreButton>Check More</CheckMoreButton>
        </StepContent>

      </StepContainer>
    </StepsSection>
  );
};

export default Illustrations;
